import { InfoOutlined } from '@mui/icons-material'
import { Stack, Tooltip, Typography, IconButton } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useOrgHasAccountingIntegration } from '@omnea-app/fe-core-data/useOrgHasAccountingIntegration'
import { theme } from '@omnea-app/omui/private/theme'

interface Props {
  type: 'supplier' | 'product'
}

export const DeletedEntityLabel = ({ type }: Props) => {
  const { t } = useTranslation('requests')
  const { hasAccountingIntegration } = useOrgHasAccountingIntegration()

  const tooltipTitle = hasAccountingIntegration
    ? t(`sidebar.labels.deleted-${type}-tooltip-accounting`)
    : t(`sidebar.labels.deleted-${type}-tooltip`)

  return (
    <Stack direction="row" alignItems="center">
      <Typography variant="HeaderSubtitleMediumMedium" color="error.dark">
        {t('sidebar.labels.deleted-entity')}
      </Typography>
      <Tooltip title={tooltipTitle}>
        <IconButton sx={{ color: theme.palette.neutralLight[700] }} size="small" edge="end">
          <InfoOutlined fontSize="small" />
        </IconButton>
      </Tooltip>
    </Stack>
  )
}
